import { Navigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { Loader2 } from 'lucide-react';

// v3.15-578: Token-first auth guard — sessionStorage (XSS-safe)
const ProtectedRoute = ({ children, requiredRole }) => {
  const { user, loading, token, authChecked } = useAuth();
  
  // v3.15-578: Check sessionStorage first, fallback to localStorage for migration
  const storedToken = sessionStorage.getItem('access_token') || localStorage.getItem('access_token');
  
  console.log('[ProtectedRoute v3.15-578] Check:', {
    loading,
    authChecked,
    contextToken: token ? 'EXISTS' : 'NULL',
    storedToken: storedToken ? 'EXISTS' : 'NULL',
    user: user?.email || 'NULL'
  });

  // If still loading initial auth, show spinner
  if (loading && !authChecked) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-slate-50">
        <div className="text-center">
          <Loader2 className="h-8 w-8 animate-spin text-accent mx-auto mb-4" />
          <p className="text-slate-600">Loading...</p>
        </div>
      </div>
    );
  }

  // FAIL SAFE - If token exists, NEVER redirect to login
  if (storedToken) {
    // Migrate localStorage → sessionStorage if needed
    if (!sessionStorage.getItem('access_token') && localStorage.getItem('access_token')) {
      sessionStorage.setItem('access_token', localStorage.getItem('access_token'));
      localStorage.removeItem('access_token');
    }
    
    // Token but no user yet = show loading while fetching user
    if (!user) {
      return (
        <div className="min-h-screen flex items-center justify-center bg-slate-50">
          <div className="text-center">
            <Loader2 className="h-8 w-8 animate-spin text-accent mx-auto mb-4" />
            <p className="text-slate-600">Authenticating...</p>
          </div>
        </div>
      );
    }
    
    if (requiredRole && user.role !== requiredRole) {
      // v3.18-1388 CRM-INT-005 — /dashboard is CEO-only; use / instead.
      return <Navigate to="/" replace />;
    }
    
    return children;
  }

  // No token at all - redirect to login
  console.log('[ProtectedRoute v3.15-578] REDIRECT - No token found');
  return <Navigate to="/login" replace />;
};

export default ProtectedRoute;
